export default {options:{version:1},children:[{options:{key:'type',type:'value'}},{options:{key:'key',type:'value'}}]}